<template>
    <template v-if="dpp.permitAvm && chartData">
        <div class="dpp-pricetrend-chart" :label="forecastLabel" v-if="chartData">
            <mvtChart :data="chartData"></mvtChart>
        </div>
        <div class="f7" v-if="showDescription">
            The estimate for {{dpp.geo.address}} is based on comparable homes below. To improve this estimate, remove homes that are not similar in the table below.
        </div>
    </template>
</template>
<script src="./mvt-estpricechart.js"></script>
<style lang="scss">
    .dpp-pricetrend-chart{
        height: 13.5rem;
        position: relative;
        .mvt-chart{
            height: 100%;
            width: 100%;
            position: relative;
        }
    }
</style>